import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Popover } from 'antd';
import { FormattedMessage as IntlMessages } from 'react-intl';
import { logout } from '@stores/reducers/auth.reducer';
import TopbarDropdownWrapper from './TopbarDropdown.styles';
import EditProfileModal from './EditProfileModal';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';



export default function TopbarUser() {
  const [visible, setVisibility] = React.useState(false);
  const [editProfileVisible, setEditProfileVisible] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(state => state.auth.user);

  function handleVisibleChange() {
    setVisibility((visible) => !visible);
  }

  const handleLogout = () => {
    dispatch(logout());
    history.push('/signin');
  };

  const content = (
    <TopbarDropdownWrapper className="isoUserDropdown">
      <div className="isoDropdownLink" onClick={() => setEditProfileVisible(true)}>
        <UserOutlined style={{ marginRight: 8 }} /> Perfil
      </div>      
      <div className="isoDropdownLink" onClick={handleLogout}>
        <LogoutOutlined style={{ marginRight: 8 }} />
        <IntlMessages id="topbar.logout" />
      </div>
    </TopbarDropdownWrapper>
  );

  return (
    <>
      <Popover
        content={content}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 120 }}>

          <div className="isoImgWrapper" style={{ minWidth: 40, minHeight: 40, width: 40, height: 40, background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
            {user?.url_photo ? (
              <img alt="user" src={user.url_photo} style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} />
            ) : (
              <span style={{ fontWeight: 700, fontSize: 18, color: '#555', textTransform: 'uppercase' }}>
                {user?.name ? user.name.trim().split(' ').map(w => w[0]).join('').substring(0, 2) : '--'}
              </span>
            )}
            <span className="userActivity online" />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ fontWeight: 600, fontSize: 14, lineHeight: 1 }}>{user?.name}</div>
            <div style={{ fontSize: 12, color: '#888', lineHeight: 1 }}>{user?.email}</div>
          </div>
        </div>
      </Popover>
      <EditProfileModal visible={editProfileVisible} onClose={() => setEditProfileVisible(false)} />
    </>
  );
}